import React from 'react'

export default function HideWidgetIcon({ color = '#64617E' }: { color?: string } = {}) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3384 16.404L7.09596 4.16162H17.7222C18.1667 4.16162 18.5473 4.32 18.864 4.63677C19.1808 4.95354 19.3389 5.33387 19.3384 5.77778V16.404ZM18.3687 20L17.0758 18.7071H6.40909C5.96465 18.7071 5.58431 18.549 5.26808 18.2327C4.95185 17.9165 4.79347 17.5359 4.79293 17.0909V6.42424L3.5 5.13131L4.63131 4L19.5 18.8687L18.3687 20ZM7.21717 15.4747H13.8232L12.1263 13.7778L11.4596 14.6667L9.64141 12.2424L7.21717 15.4747Z" fill={color}/>
        </svg>
    )
}
